import React from 'react';
import { Button } from './ui/Button';
import { Check, Shield, Zap, Lock } from 'lucide-react';
const URL_COMBO = 'https://www.compradigitalya.com/cart/42804528906311:1';
export function Pricing() {
  return <section id="pricing" className="py-16 md:py-24 px-4 max-w-4xl mx-auto scroll-mt-16" data-id="element-351">
      <div className="text-center mb-12" data-id="element-352">
        <h2 className="text-3xl md:text-5xl font-extrabold mb-4 tracking-tight" data-id="element-353">
          Tu año resuelto, <span className="text-primary" data-id="element-354">hoy.</span>
        </h2>
        <div className="inline-flex items-center gap-2 bg-primary/15 border border-primary/30 rounded-full px-4 py-1.5 text-[11px] md:text-sm font-bold text-primary uppercase tracking-wider" data-id="element-355">
          🔥 Precio promocional de lanzamiento
        </div>
      </div>

      <div className="bg-surface border-2 border-primary rounded-3xl p-8 md:p-12 flex flex-col md:flex-row gap-10 shadow-[0_0_50px_rgba(249,168,212,0.15)]" data-id="element-356">
        {/* Left: Features */}
        <div className="flex-1" data-id="element-357">
          <h3 className="text-2xl md:text-3xl font-extrabold text-white mb-2" data-id="element-358">
            Combo Completo HIIT Pro
          </h3>
          <p className="text-primary font-medium mb-8" data-id="element-359">
            6 Tomos + 6 Bonos Exclusivos
          </p>

          <ul className="space-y-4 mb-8" data-id="element-360">
            {['300+ clases listas para aplicar', '52 semanas de periodización', 'Variantes por nivel (Básico a Avanzado)', 'Protocolos científicos listos', '6 Bonos estratégicos de regalo', 'Acceso inmediato y de por vida'].map((f, i) => <li key={i} className="flex items-start gap-3" data-id="element-361">
                <div className="mt-1 bg-primary/20 p-1 rounded-full shrink-0" data-id="element-362">
                  <Check className="w-3 h-3 text-primary" data-id="element-363" />
                </div>
                <span className="text-zinc-200 font-medium" data-id="element-364">{f}</span>
              </li>)}
          </ul>
        </div>

        {/* Right: Price & CTA */}
        <div className="flex-1 flex flex-col justify-center bg-black rounded-2xl p-8 border border-zinc-800" data-id="element-365">
          <div className="mb-8" data-id="element-366">
            <div className="text-zinc-500 line-through text-lg font-bold mb-1" data-id="element-367">
              Antes: $51.900
            </div>
            <div className="text-primary text-sm font-bold uppercase tracking-wider mb-1" data-id="element-368">
              Ahora
            </div>
            <div className="text-5xl md:text-6xl font-extrabold text-white" data-id="element-369">
              $19.990 <span className="text-2xl text-zinc-500" data-id="element-370">ARS</span>
            </div>
          </div>

          <Button href={URL_COMBO} className="py-5 text-lg md:text-xl w-full mb-6 shadow-[0_0_30px_rgba(249,168,212,0.3)]" data-id="element-371">
            QUIERO MI COMBO AHORA
          </Button>

          <div className="flex flex-col gap-3 text-sm text-zinc-400 font-medium" data-id="element-372">
            <span className="flex items-center justify-center gap-2" data-id="element-373">
              <Shield className="w-4 h-4 text-primary" data-id="element-374" /> Garantía de 7 días
            </span>
            <span className="flex items-center justify-center gap-2" data-id="element-375">
              <Zap className="w-4 h-4 text-primary" data-id="element-376" /> Acceso en 5 minutos
            </span>
            <span className="flex items-center justify-center gap-2" data-id="element-377">
              <Lock className="w-4 h-4 text-primary" data-id="element-378" /> Pago 100% seguro
            </span>
          </div>
        </div>
      </div>
    </section>;
}